import React from "react";
import {
  FieldPath,
  FieldValues,
  useController,
  UseControllerProps,
} from "react-hook-form";
import {
  AddNumberDelimiter,
  RemoveNumberDelimiter,
} from "../../../utils/TextUtil";

type Props = {
  id: string;
  className?: string;
};

function DelimitedNumberField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({ className, ...props }: UseControllerProps<TFieldValues, TName> & Props) {
  const { field } = useController(props);

  return (
    <input
      {...field}
      id={props.id}
      type="text"
      inputMode="numeric"
      className={className}
      value={AddNumberDelimiter(field.value ?? "")}
      onChange={(event) =>
        field.onChange(RemoveNumberDelimiter(event.target.value))
      }
    />
  );
}

export default DelimitedNumberField;
